import OrderHistoryItem from '../OrderHistoryItem/order-history-item';

export default OrderHistoryItem;